import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// A prerendered page (#75) carries its own title, meta and canonical tags marked data-prerender. React adds the
// page's tags again when it renders, so drop the snapshot's first rather than leave two of each.
document.querySelectorAll("head [data-prerender]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
